import { createContext } from 'react'
import { DeliveryContextType } from '../../types/models'

export const DeliveryContext = createContext<DeliveryContextType>(
  {} as DeliveryContextType
)
